'use es6';

import { FINDER_OPEN_ACTION_MODAL, FINDER_CLOSE_ACTION_MODAL } from 'DesignData/actions/ActionTypes';
export default function actionModal(state = null, action) {
  switch (action.type) {
    case FINDER_OPEN_ACTION_MODAL:
      return action.modal;

    case FINDER_CLOSE_ACTION_MODAL:
      return null;

    default:
      return state;
  }
}